import { LogSource } from '@24i/player-base';

export const Logger = new LogSource('packageName', 'packageVersion');